import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 0;
`;

export const ErrorText = styled.div`
  color: #ef4444;
  font-size: 0.85rem;
`;
